import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApisService {
  public baseUrl = environment.baseUrl;
  private headers: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      // accesskey: this.accessKey,
      // Authorization: `Bearer ${this.token}`,
    }),
  };

  constructor(private http: HttpClient) {}



  /** =============================== contact =============================== */

  /**
   * @description firstName, lastName, email, subject, message
   */
  contactUs(data: any) {
    return this.http.post(`${this.baseUrl}/contact-us`, data, this.headers);
  }


  /** =============================== Testimony =============================== */

  /**
   * @description get all the testimony from the server
   */
  getAllTestimony() {
    return this.http.get(`${this.baseUrl}/testimonials`, this.headers);
  }
  getTestimonyByID(param: any) {
    return this.http.get(`${this.baseUrl}/testimonials/${param}`, this.headers);
  }
  postTestimony(param: any) {
    return this.http.post(`${this.baseUrl}/testimonials`, param, this.headers);
  }

  /** =============================== courses =============================== */

  /**
   * @description get all the testimony from the server
   */
  getCourses() {
    return this.http.get(`${this.baseUrl}/training`, this.headers);
  }

    /** =============================== country =============================== */

  /**
   * @description get all the all countries from the server
   */
  getCountry() {
    return this.http.get(`https://restcountries.com/v3.1/all`, this.headers);
  }

  /** =============================== become merchant =============================== */

  /**
   * @description send become merchant to the server
   */
  becomeMerchant(param: any) {
    return this.http.post(`${this.baseUrl}/merchants`, param, this.headers);
  }
    becomeAgent(param: any) {
      return this.http.post(`${this.baseUrl}/agent`, param, this.headers);
    }
  /** =============================== checkout url =============================== */

  /**
   * @description checkout url
   */
  checkout(param: any) {
    return this.http.post(`https://pay.huiospay.com/api/v1/session?merchant_key=7084d73a-6850-11ee-abcc-6af4ec846580&CHECKOUT_HOST=https://pay.huiospay.com`, param, this.headers);
  }
}
